export const SUBNAME_RENAME_ENABLED = false;
